const getMuiButtonBase = () => ({
  defaultProps: {
    disableRipple: true, // Disable ripple effect for all buttons
  },
});

export default getMuiButtonBase;
